<div class="container-fluid px-0 setup-page-main">

  <div class="container-fluid cardGroup px-0">
    <div class="row justify-content-between align-items-center net-sales-details-RTL">
      <div class="col-md-8">
        <h1 class="text-black f-14 fw-600">{{ selectDateoption }}</h1>
      </div>
      <div class="col-md-4 w-fit">
        <div class="input-group mb-2">
          <div ngbDropdown class="input-group-text p-0 border-color-input">
            <button
              class="btn datepicker-btn"
              id="periodDropDown"
              ngbDropdownToggle
            >
              {{ selectDateoption | translate | async }} <i class="mdi mdi-menu-up up"></i
              ><i class="mdi mdi-menu-down down"></i>
            </button>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownBasic1"
              class="fw-500 f-12"
            >
              <ng-container *ngFor="let type of dateFilteroptions">
                <button
                  ngbDropdownItem
                  [ngClass]="selectDateoption === type ? 'disabled' : ''"
                  [disabled]="selectDateoption === type"
                  (click)="selectedDateOption(type)"
                >
                  {{ type | translate | async }}
                </button>
              </ng-container>
            </div>
          </div>
          <div
            class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
          >
            <div class="datepickerwrap form-control" (click)="picker.open()">
              <span class="date-text ms-2">
                <span class="display-date">{{
                  startDateDisplayFormatted | translate | async
                }}</span>
                -
                <span class="display-date">{{ endDateDisplayFormatted| translate | async }}</span>
              </span>
              <img
                src="../../../../assets/images/dashboard-images/bx-calendar.png"
                class="ms-3 picker-icon"
              />

              <div class="mat-datepicker-hide">
                <mat-date-range-input [rangePicker]="picker">
                  <input
                    matStartDate
                    placeholder="Start date"
                    [(ngModel)]="a1"
                  />
                  <input
                    matEndDate
                    placeholder="End date"
                    [(ngModel)]="a2"
                    (ngModelChange)="selectedDate($event)"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="row dashboard-card-details">
        <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
          <div class="mini-card">
            <div class="row g-0 net-dashboard-row">
              <div class="col-8">
                <div class="f-14 mb-1 fw-600 net-deshboard-sales">
                  {{ "Net Sales" | translate | async }}
                  <i
                    class="f-10 fas fa-info-circle vertical-align-super"
                    [ngbPopover]="'Net sales is the total amount of sales revenue generated after deducting discounts, taxes, and returns from gross sales.' | translate | async"
                    triggers="mouseenter:mouseleave"
                    [popoverTitle]="'Net Sales' | translate | async"
                    placement="right"
                  ></i>
                </div>
                <div class="pb-2 net-dashboard-details">
                  <span
                      [ngClass]="
                        checkNegative(cardData?.sale?.percentage)
                          ? 'danger-badge'
                          : checkZeroInc(cardData?.sale?.percentage)
                          ? 'zero-badge'
                          : 'sucess-badge'
                      "
                      class="f-12 text-nowrap ms-0"
                    >
                    <!-- change -->
                      {{
                        checkNegative(cardData?.sale?.percentage)
                          ? cardData?.sale?.percentage
                          : showPlusData(cardData?.sale?.percentage)
                      }}%
                      </span>
                </div>
              <div class="d-flex net-dashboard-currency">
                <h6 class="fw-600 f-14 d-flex gap-1">
                  <div class="sales-card-width-currency">{{ currency }}</div>
                  <div class="sales-card-width" >
                    {{ cardData?.sale?.value | lakhSeparator }}

                  </div>
                  <!-- {{ currency + " " + (cardData?.sale?.value | number : '.2-2') }} -->
                </h6>

              </div>
              </div>
              <div class="col-4">
                <div class="eos--icon net-sales"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
          <div class="mini-card">
            <div class="row g-0 align-items-start net-dashboard-row">
              <div class="col-9">
                <div class="f-14 mb-1 fw-600 net-deshboard-sales">
                  {{ "Total Orders" | translate | async }}
                  <i
                    class="f-10 fas fa-info-circle vertical-align-super"
                    [ngbPopover]="'Total Orders: an overview of all orders made and processed.' | translate | async"
                    triggers="mouseenter:mouseleave"
                    [popoverTitle]="'Total Orders' | translate | async"
                    placement="right"
                  ></i>
                </div>
                <div class="pb-2 net-dashboard-details">
                  <span
                    [ngClass]="
                      checkNegative(cardData?.order?.percentage)
                        ? 'danger-badge'
                        : checkZeroInc(cardData?.order?.percentage)
                        ? 'zero-badge'
                        : 'sucess-badge'
                    "
                    class="f-12 text-nowrap ms-0"
                  >
                    {{
                      checkNegative(cardData?.order?.percentage)
                        ? cardData?.order?.percentage
                        : showPlusData(cardData?.order?.percentage)
                    }}%</span
                  >
                </div>
                <div class="d-flex net-dashboard-currency">
                  <h6 class="fw-600 f-14 sales-card-width"  >
                    {{ cardData?.order?.value | lakhSeparator }}
                  </h6>
                </div>
              </div>
              <div class="col-3">
                <div class="eos--icon total-orders"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
          <div class="mini-card">
            <div class="row g-0 net-dashboard-row">
              <div class="col-8">
                <div class="f-14 mb-1 fw-600 net-deshboard-sales">
                  {{ "Total Transactions" | translate | async }}
                  <i
                    class="f-10 fas fa-info-circle vertical-align-super"
                    [ngbPopover]="'Total Transactions: Comprehensive, cumulative transactions data. Detailed records of sales, purchases and payments.' | translate | async"
                    triggers="mouseenter:mouseleave"
                    [popoverTitle]="'Total Transactions' | translate | async"
                    placement="right"
                  ></i>
                </div>
                <div class="pb-2 net-dashboard-details">
                  <span
                  [ngClass]="
                    checkNegative(cardData?.transaction?.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(cardData?.transaction?.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                  class="f-12 text-nowrap ms-0"
                >
                  {{
                    checkNegative(cardData?.transaction?.percentage)
                      ? cardData?.transaction?.percentage
                      : showPlusData(cardData?.transaction?.percentage)
                  }}%</span
                >
                </div>
            <div class="d-flex net-dashboard-currency">
              <h6 class="fw-600 f-14 sales-card-width"  >
                {{ cardData?.transaction?.value | lakhSeparator }}
              </h6>

            </div>
              </div>
              <div class="col-4">
                <div class="eos--icon total-transactions"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
          <div class="mini-card">
            <div class="row g-0 net-dashboard-row">
              <div class="col-8">
                <div class="f-14 mb-1 fw-600 net-deshboard-sales">
                  {{ "Total Refunds" | translate | async }}
                  <i
                    class="f-10 fas fa-info-circle vertical-align-super"
                    [ngbPopover]="'Total Refunded: The total amount returned to customers due to a purchase cancellation or return.' | translate | async"
                    triggers="mouseenter:mouseleave"
                    [popoverTitle]="'Total Refunds' | translate | async"
                    placement="right"
                  ></i>
                </div>
                <div class="pb-2 net-dashboard-details">
                  <span
                    [ngClass]="
                      checkNegative(cardData?.refund?.percentage)
                        ? 'danger-badge'
                        : checkZeroInc(cardData?.refund?.percentage)
                        ? 'zero-badge'
                        : 'sucess-badge'
                    "
                    class="f-12 text-nowrap ms-0"
                  >
                    {{
                      checkNegative(cardData?.refund?.percentage)
                        ? cardData?.refund?.percentage
                        : showPlusData(cardData?.refund?.percentage)
                    }}%</span
                  >
                </div>
                <div class="d-flex net-dashboard-currency">
                  <h6 class="fw-600 f-14 d-flex gap-1">
                    <div class="sales-card-width-currency" >{{ currency }}</div>
                      <div class="sales-card-width"  >
                        {{ cardData?.refund?.value | lakhSeparator  }}
                      </div>

                  </h6>

                </div>
              </div>
              <div class="col-4">
                <div class="eos--icon total-refunds"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 page-card-main">
          <div class="mini-card">
            <div class="row g-0 net-dashboard-row">
              <div class="col-8">
                <div class="f-14 mb-1 fw-600 net-deshboard-sales">
                  {{ "Total Discounts" | translate | async }}
                  <i
                    class="f-10 fas fa-info-circle vertical-align-super"
                    [ngbPopover]="'Total Discounts: The total amount of discounts that have been processed over a given period of time' | translate | async"
                    triggers="mouseenter:mouseleave"
                    [popoverTitle]="'Total Discounts' | translate | async"
                    placement="bottom"
                  ></i>
                </div>
                <div class="pb-2 net-dashboard-details">
                  <span
                  [ngClass]="
                    checkNegative(cardData?.discount?.percentage)
                      ? 'danger-badge'
                      : checkZeroInc(cardData?.discount?.percentage)
                      ? 'zero-badge'
                      : 'sucess-badge'
                  "
                  class="f-12 text-nowrap ms-0"
                >
                  {{
                    checkNegative(cardData?.discount?.percentage)
                      ? cardData?.discount?.percentage
                      : showPlusData(cardData?.discount?.percentage)
                  }}%</span
                >
                </div>
              <div class="d-flex net-dashboard-currency">
                <h6 class="fw-600 f-14 d-flex gap-1">
                  <div class="sales-card-width-currency">{{ currency }}</div>
                  <div class="sales-card-width"> {{ cardData?.discount?.value | lakhSeparator  }}</div>
                </h6>
              </div>
              </div>
              <div class="col-4">
                <div class="eos--icon total-discounts"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div class="col-12">
    <!-- Net Sales -->
    <div class="card" *ngIf="!emptyNetSales">
      <div class="card-body">
        <h5>{{ "Net Sales" | translate | async }}</h5>
        <ng-container *ngIf="!netSaleLoader">
          <apx-chart id="net-sales" class="apex-charts" dir="ltr" [series]="netSalesChart.series" [chart]="netSalesChart.chart"
            [plotOptions]="netSalesChart.plotOptions" [dataLabels]="netSalesChart.dataLabels" [xaxis]="netSalesChart.xaxis"
            [yaxis]="netSalesChart.yaxis" [colors]="netSalesChart.colors">
          </apx-chart>
        </ng-container>

        <ng-container *ngIf="netSaleLoader" height="400px">
          <div class="grapgh-loader">
            <span class="loader1"></span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Overall Reports Table -->
    <div class="card" *ngIf="!emptySummaryReport">
      <div class="card-body">
        <div class="table-responsive mb-0">
          <h5 class="fw-600 mb-4 font-size-20-d">
            {{ "Overall Reports" | translate | async }}
          </h5>
          <ng-container *ngIf="!summaryReportLoader">
            <table class="table table-centered table-nowrap">
              <thead class="table-light">
                <tr>
                  <th class="align-middle">{{ "Store Name" | translate | async }}</th>
                  <th class="align-middle">{{ "Gross Sales" | translate | async }}</th>
                  <th class="align-middle">{{ "Net Sales" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Orders" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Transactions" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Refunds" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Discounts" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Tax" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Tips" | translate | async }}</th>
                  <th class="align-middle">{{ "Total Delivery Fees" | translate | async }}</th>
                  <!-- <th class="align-middle">View Details</th> -->
                </tr>
              </thead>
              <tbody>
                <tr class="align-middle" *ngFor="let restaurant of restaurants">
                  <td>{{ restaurant.storeName }}</td>
                  <td>{{ currency }}{{ restaurant.grossSales | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.netSales | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.totalOrders | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.totalTransactions | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.totalRefunds | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.discounts | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.tax | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.tips | number : ".2-2" }}</td>
                  <td>{{ currency }}{{ restaurant.deliveryAmount | number : ".2-2" }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
          <ng-container *ngIf="summaryReportLoader" height="400px">
            <div class="grapgh-loader">
              <span class="loader1"></span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Total Orders & Total Total -->
    <div class="card" *ngIf="!emptyTotalOrdersAndTransactions">
      <div class="card-body">
        <h5>{{ "Total Orders & Total Transactions" | translate | async }}</h5>
        <ng-container *ngIf="!totalOrdersAndTransactionsLoader">
          <apx-chart class="apex-charts" dir="ltr" [series]="totalOrdersAndTransactionsChart.series" [chart]="totalOrdersAndTransactionsChart.chart"
            [plotOptions]="totalOrdersAndTransactionsChart.plotOptions" [yaxis]="totalOrdersAndTransactionsChart.yaxis" [grid]="totalOrdersAndTransactionsChart.grid"
            [tooltip]="totalOrdersAndTransactionsChart.tooltip" [stroke]="totalOrdersAndTransactionsChart.stroke"
            [dataLabels]="totalOrdersAndTransactionsChart.dataLabels" [xaxis]="totalOrdersAndTransactionsChart.xaxis" [colors]="totalOrdersAndTransactionsChart.colors"
            [fill]="totalOrdersAndTransactionsChart.fill">
          </apx-chart>
        </ng-container>

        <ng-container *ngIf="totalOrdersAndTransactionsLoader" height="400px">
          <div class="grapgh-loader">
            <span class="loader1"></span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Total Refunds, Discounts, Tax, and Tips -->
    <div class="card" *ngIf="!emptyTotalMetrics">
      <div class="card-body">
        <h5>{{ "Total Refunds, Discounts, Tax, and Tips" | translate | async }}</h5>
        <ng-container *ngIf="!totalMetricsLoader">
          <apx-chart class="apex-charts" dir="ltr" [series]="totalMetricsChart.series" [chart]="totalMetricsChart.chart"
            [plotOptions]="totalMetricsChart.plotOptions" [yaxis]="totalMetricsChart.yaxis" [grid]="totalMetricsChart.grid"
            [tooltip]="totalMetricsChart.tooltip" [stroke]="totalMetricsChart.stroke"
            [dataLabels]="totalMetricsChart.dataLabels" [xaxis]="totalMetricsChart.xaxis" [colors]="totalMetricsChart.colors"
            [fill]="totalMetricsChart.fill">
          </apx-chart>
        </ng-container>

        <ng-container *ngIf="totalMetricsLoader">
          <div class="grapgh-loader">
            <span class="loader1"></span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Top 5 Transactions by Type -->
    <div class="card" *ngIf="!emptyTopTransactionsByType">
      <div class="card-body">
        <h5>{{ "Top 5 Transactions by Type" | translate | async }}</h5>
        <ng-container *ngIf="!topTransactionsByTypeLoader">
          <apx-chart class="apex-charts" dir="ltr" [series]="topTransactionsByTypeChart.series" [chart]="topTransactionsByTypeChart.chart"
            [plotOptions]="topTransactionsByTypeChart.plotOptions" [yaxis]="topTransactionsByTypeChart.yaxis" [grid]="topTransactionsByTypeChart.grid"
            [tooltip]="topTransactionsByTypeChart.tooltip" [stroke]="topTransactionsByTypeChart.stroke"
            [dataLabels]="topTransactionsByTypeChart.dataLabels" [xaxis]="topTransactionsByTypeChart.xaxis" [colors]="topTransactionsByTypeChart.colors"
            [fill]="topTransactionsByTypeChart.fill">
          </apx-chart>
        </ng-container>

        <ng-container *ngIf="topTransactionsByTypeLoader">
          <div class="grapgh-loader">
            <span class="loader1"></span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Top 5 Products -->
    <div class="card" *ngIf="!emptyTopProducts">
      <div class="card-body">
        <h5>{{ "Top 5 Products" | translate | async }}</h5>
        <ng-container *ngIf="!topProductsLoader">
          <apx-chart class="apex-charts" dir="ltr" [series]="topProductsChart.series" [chart]="topProductsChart.chart"
            [plotOptions]="topProductsChart.plotOptions" [yaxis]="topProductsChart.yaxis" [grid]="topProductsChart.grid"
            [tooltip]="topProductsChart.tooltip" [stroke]="topProductsChart.stroke"
            [dataLabels]="topProductsChart.dataLabels" [xaxis]="topProductsChart.xaxis" [colors]="topProductsChart.colors"
            [fill]="topProductsChart.fill">
          </apx-chart>
        </ng-container>

        <ng-container *ngIf="topProductsLoader">
          <div class="grapgh-loader">
            <span class="loader1"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
